import React, { memo, useState } from 'react'
import PropTypes from 'prop-types'
import IconButton from '@material-ui/core/IconButton'
import InputAdornment from '@material-ui/core/InputAdornment'
import { withField } from '../Field'
import { onKeyDownNumber, onPasteNumber } from '../utils'
import { StyledInput, StyledInputWrap } from './styled'
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'

const visibilityIconStyle = { color: '#9e9e9e', fontSize: 22 }

const getInputProps = (type, inputProps) => {
  if (type === 'number') {
    return {
      ...inputProps,
      onPaste: onPasteNumber,
      onKeyDown: onKeyDownNumber
    }
  }

  return inputProps
}

function Input (props) {
  const {
    inputProps,
    fnValidData,
    onChange,
    hasPasswordViewer,
    type,
    InputProps: inputPropsFromParent,
    ...rest
  } = props
  const [isVisibilityOn, setIsVisibilityOn] = useState(false)

  const handleChange = (evt) => {
    if (fnValidData(evt.target.value)) {
      onChange(evt)
    }
  }

  const inputType = hasPasswordViewer && isVisibilityOn ? 'text' : type
  const showPasswordToggle = hasPasswordViewer && type === 'password'

  const passwordToggleAdornment = showPasswordToggle ? (
    <InputAdornment position="end">
      <IconButton
        edge="end"
        tabIndex={-1}
        aria-label={isVisibilityOn ? 'Ocultar senha' : 'Mostrar senha'}
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => setIsVisibilityOn(prev => !prev)}
      >
        {isVisibilityOn
          ? <VisibilityIcon style={visibilityIconStyle} />
          : <VisibilityOffIcon style={visibilityIconStyle} />}
      </IconButton>
    </InputAdornment>
  ) : null

  const mergedInputProps = showPasswordToggle
    ? { ...inputPropsFromParent, endAdornment: passwordToggleAdornment }
    : inputPropsFromParent

  return (
    <StyledInputWrap>
      <StyledInput
        className="inputForm"
        {...rest}
        type={inputType}
        InputProps={mergedInputProps}
        inputProps={getInputProps(inputType, inputProps)}
        onChange={handleChange}
      />
    </StyledInputWrap>
  )
}

Input.propTypes = {
  type: PropTypes.string,
  inputProps: PropTypes.object,
  InputProps: PropTypes.object,
  noMarginTop: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  fnValidData: PropTypes.func,
  dataTestId: PropTypes.string,
  hasPasswordViewer: PropTypes.bool
}

Input.defaultProps = {
  type: 'text',
  inputProps: {},
  InputProps: undefined,
  noMarginTop: false,
  fnValidData: () => true,
  dataTestId: null,
  hasPasswordViewer: false
}

export { Input }
export default memo(withField(Input))
